/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionStartTrial } from '../../axios/subscriptionStartTrial'
import type {
	SubscriptionStartTrialError,
	SubscriptionStartTrialPathParams,
	SubscriptionStartTrialRequest,
	SubscriptionStartTrialResponse,
} from '../../types/SubscriptionStartTrial'

export const subscriptionStartTrialMutationKey = () => [{ url: '/:organisation/profiles/:profile/trial' }] as const

export type SubscriptionStartTrialMutationKey = ReturnType<typeof subscriptionStartTrialMutationKey>

export type SubscriptionStartTrialVariables = {
	organisation: SubscriptionStartTrialPathParams['organisation']
	profile: SubscriptionStartTrialPathParams['profile']
	data: SubscriptionStartTrialRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::startTrial */
export function useSubscriptionStartTrial<TContext = unknown>(
	options?: UseMutationOptions<
		SubscriptionStartTrialResponse,
		AxiosError<SubscriptionStartTrialError>,
		SubscriptionStartTrialVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: subscriptionStartTrialMutationKey(),
		mutationFn: ({ organisation, profile, data }: SubscriptionStartTrialVariables) =>
			subscriptionStartTrial(organisation, profile, data, config).then(res => res.data),
		...options,
	})
}
